<template>
  <svg class="icon" aria-hidden="true">
    <use :xlink:href="href"></use>
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    href() {
      return `#${this.name}`;
    }
  }
}
</script>